/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { ExportPricesDto, ExportPricesLinkDto } from './export-prices.dto';

export const ExportPricesMapper = entity<ExportPricesDto>();
export const ExportPricesLinkMapper = entity<ExportPricesLinkDto>();
